import React from 'react';
import {PlanGetSchema} from '../../../../api/DBSchema/Plan';
import BaseRemoteAccess from '../../AbstractObjects/GatewayPlan/InnerPages/BaseRemoteAccess';

const pageSchema = PlanGetSchema.pages.remoteAccess;
const pageId = pageSchema.pageId;

function PlanRemoteAccess({
    planObject,
    setPlanData
}) {

    let pageData = planObject[pageId];
    
    return (
        <BaseRemoteAccess
            pageData={pageData}
            setObjectData={setPlanData}
        />
    );
}

export default PlanRemoteAccess;